module.exports = __webpack_public_path__ + "r-v3/img/ico_camera_black.d44cc42d.svg";